import styled from "styled-components";
import { theme } from "styles/theme";

export const SummaryCard = styled.div`
  background-color: ${theme.colors.surface};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.border};
  box-shadow: none;
  margin-bottom: 1.5rem;
  display: flex;
  overflow: hidden;

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const DeviceInfoSection = styled.div`
  flex: 1;
  padding: 1.25rem 1.5rem;
`;

export const MapSection = styled.div`
  flex: 1;
  min-height: 250px;
  background-color: ${theme.colors.bgLight};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SectionTitle = styled.h2`
  color: ${theme.colors.textPrimary};
  font-size: 1.15rem;
  margin: 0.25rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${theme.colors.border};
  font-weight: ${theme.fontWeights.medium};
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${theme.colors.borderLight};

  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  color: ${theme.colors.textSecondary};
  font-size: 0.875rem;
`;

export const DetailValue = styled.span`
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.textPrimary};
  text-align: right;
`;

export const ConnectionStatus = styled.div<{ connected: boolean }>`
  font-size: 0.875rem;
  color: ${(props) =>
    props.connected ? theme.colors.tertiary : theme.colors.error};
  display: inline-flex;
  align-items: center;
`;

export const EditIcon = styled.i`
  margin-left: 8px;
  cursor: pointer;
  font-size: 0.85rem;
  color: ${theme.colors.textMuted};
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${theme.colors.textPrimary};
  }
`;

export const AddressContainer = styled.div`
  display: flex;
  align-items: center;
`;
